<main class="blog-page">
  <section class="blog-intro">
    <p class="eyebrow">{{ copy().blogEyebrow }}</p>
    <h1>{{ copy().blog }}</h1>
    <p>
      {{ copy().blogTitle }}
    </p>
  </section>

  <section class="article-grid" aria-label="{{ appName }} articles">
    @for (article of articles; track article.slug) {
      <article class="article-card">
        <a
          class="article-art {{ article.accent }}"
          [routerLink]="'/blog/' + article.slug"
          [attr.aria-label]="'Read ' + article.title"
        >
          <span class="art-label">{{ article.category }}</span>
          <strong>{{ article.title }}</strong>
          <span class="art-shape" aria-hidden="true"></span>
        </a>
        <div class="article-copy">
          <span class="article-category">{{ article.category }}</span>
          <h2>
            <a [routerLink]="'/blog/' + article.slug">{{ article.title }}</a>
          </h2>
          <p>{{ article.excerpt }}</p>
          <footer>
            <span>{{ appName }} editorial team · {{ article.date }}</span
            ><span>{{ article.readTime }}</span>
          </footer>
          <a class="article-link" [routerLink]="'/blog/' + article.slug"
            >{{ copy().blogRead }}
          </a>
        </div>
      </article>
    }
  </section>

  <section class="blog-cta">
    <div>
      <p class="eyebrow">{{ copy().blogEyebrow }}</p>
      <h2>{{ copy().footerReady }}</h2>
    </div>
    <a class="primary-button" routerLink="/chat">Start chatting </a>
  </section>
</main>
